import styled from 'styled-components'

import { TreeSelect } from '../../../common/components/sections'

const StyledIgnoredDishTypeModalTreeSelect = styled(TreeSelect)`
  flex: 1;
`

export default StyledIgnoredDishTypeModalTreeSelect
